import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ChevronDown } from "lucide-react";

type Option =
    | "Today"
    | "Yesterday"
    | "Today + Yesterday"
    | "Last 7 Days"
    | "Last 30 days"
    | "Last Month"
    | "Last Quarter"
    | "Last Year"
    | "This Year"
    | "Custom range";

const options: Option[] = [
    "Today",
    "Yesterday",
    "Today + Yesterday",
    "Last 7 Days",
    "Last 30 days",
    "Last Month",
    "Last Quarter",
    "Last Year",
    "This Year",
    "Custom range",
];

const TimelineDropdown: React.FC = () => {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState<Option>("Today");
    const [customStart, setCustomStart] = useState<Date | null>(null);
    const [customEnd, setCustomEnd] = useState<Date | null>(null);

    const handleSelect = (option: Option) => {
        setSelected(option);
        if (option !== "Custom range") {
            setOpen(false);
        }
    };

    return (
        <div className="relative w-64">
            {/* Trigger Button */}
            <button
                onClick={() => setOpen(!open)}
                className="flex items-center justify-between w-full px-4 py-2 bg-gray-200 rounded-md"
            >
                <span className="text-gray-700 font-medium">Timeline {selected}</span>
                <ChevronDown className="w-4 h-4 text-gray-600" />
            </button>

            {/* Dropdown */}
            {open && (
                <div className="absolute mt-2 w-full bg-white shadow-lg rounded-xl z-20">
                    {options.map((option) => {
                        const isSelected = selected === option;

                        return (
                            <div
                                key={option}
                                onClick={() => handleSelect(option)}
                                className={`px-4 py-2 cursor-pointer hover:bg-gray-100 
            ${isSelected && option !== "Custom range" ? "bg-gray-100 font-medium" : ""}`}
                            >
                                {option}

                                {/* Custom Range UI */}
                                {option === "Custom range" && isSelected && (
                                    <div className="mt-3 px-2 pb-3">
                                        <div className="flex items-center space-x-4">
                                            <div className="flex flex-col w-1/2">
                                                <label className="text-sm text-gray-600 mb-1">From</label>
                                                <DatePicker
                                                    selected={customStart}
                                                    onChange={(date) => setCustomStart(date)}
                                                    selectsStart
                                                    startDate={customStart}
                                                    endDate={customEnd}
                                                    className="border rounded-md px-2 py-1 text-sm w-full"
                                                    placeholderText="Select date"
                                                />
                                            </div>
                                            <div className="flex flex-col w-1/2">
                                                <label className="text-sm text-gray-600 mb-1">To</label>
                                                <DatePicker
                                                    selected={customEnd}
                                                    onChange={(date) => setCustomEnd(date)}
                                                    selectsEnd
                                                    startDate={customStart}
                                                    endDate={customEnd}
                                                    minDate={customStart}
                                                    className="border rounded-md px-2 py-1 text-sm w-full"
                                                    placeholderText="Select date"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}

        </div>
    );
};

export default TimelineDropdown;
